function download(href, filename) {
  const el = document.createElement('a')
  el.href = href
  el.download = filename

  // Explicitly add created element to the DOM for Firefox
  document.body.appendChild(el)

  el.click()
  el.remove()
}

export function downloadFile(data, fileName, type) {
  const file = new Blob([data], { type })
  download(URL.createObjectURL(file), fileName)
}

export function downloadLink(link, filename) {
  download(link, filename)
}

export function downloadJSONasCSV(data, filename = 'data.csv') {
  if (!data || data.length === 0) {
    return
  }

  // Headers are unioned across every row, in first-seen order. Taking them from
  // the first row alone drops any field that row happens to omit — JSON leaves
  // out undefined values, so an optional field absent from row one would be
  // missing from the export even where later rows have it.
  const keys = [...new Set(data.flatMap((row) => Object.keys(row)))]
  const csvRows = [keys.join(',')] // Add headers as the first row

  // Map each JSON object to a CSV row
  data.forEach((item) => {
    const values = keys.map((key) => {
      const value = item[key] ?? '' // Don't allow null/undefined
      let escaped = ('' + value).replace(/"/g, '""') // Escape double quotes

      // Enforce numbers with leading zeros to be interpreted as text
      if (typeof value === 'string' && /^[0-9]+$/.test(value)) {
        return `="${escaped}"` // Force Excel to interpret as text
      }

      return `"${escaped}"` // Wrap values in double quotes for CSV
    })
    csvRows.push(values.join(','))
  })

  // Join all rows with newline character
  const csvContent = csvRows.join('\n')

  // UTF-8 BOM added to help charset with excel file
  const BOM = '\uFEFF'
  const file = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })

  // Initiate download
  download(URL.createObjectURL(file), filename)
}
